/**
 * @file 工具列表数据
 * @author FengGuang(fengguang01@baidu.com)
 */

export interface IMoreListItem {
    title: string;
    text: string;
    btnText: string;
    btnLink: string;
    btnTarget?: string;
}

const toolListData: IMoreListItem[] = [
    {
        title: '中文NLP工具集',
        text: '涵盖文本分类、序列标注、语义匹配等多种NLP任务的解决方案，拥有当前业内效果领先的中⽂语义表示模型和基于用户大数据训练的应⽤任务模型，且同类型算法模型可灵活插拔',
        btnText: '了解更多',
        btnLink: '/nlptools',
        btnTarget: '_blank'
    },
    {
        title: '视频分类工具集',
        text: '提供适合视频分类任务的通用骨架代码，覆盖主流视频分类模型，包括Non-local、TSM、Attention Cluster、NeXtVLAD、Attention LSTM、StNet、TSN。用户可一键式高效配置模型完成训练和评测',
        btnText: '了解更多',
        btnLink: 'https://github.com/PaddlePaddle/models/tree/develop/PaddleCV/PaddleVideo',
        btnTarget: '_blank'
    }
];

export default toolListData;
